interface VoteButtonsProps {
  votes: Record<string, 1 | -1>
  onVote: (vote: 1 | -1 | 0) => void | Promise<void>
  currentUserId?: string
}

export function VoteButtons({ votes, onVote, currentUserId = 'me' }: VoteButtonsProps) {
  const myVote = votes[currentUserId] ?? 0
  const ups = Object.values(votes).filter((v) => v > 0).length
  const downs = Object.values(votes).filter((v) => v < 0).length

  return (
    <div className="cg-votes" style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <button
        className="cg-vote up"
        data-active={myVote > 0}
        onClick={(e) => { e.stopPropagation(); onVote(myVote > 0 ? 0 : 1) }}
        title="Upvote"
      >
        <svg width="11" height="11" viewBox="0 0 12 12" fill="currentColor">
          <path d="M6 1 L11 8 L7 8 L7 11 L5 11 L5 8 L1 8 Z" />
        </svg>
        <span>{ups}</span>
      </button>

      <button
        className="cg-vote down"
        data-active={myVote < 0}
        onClick={(e) => { e.stopPropagation(); onVote(myVote < 0 ? 0 : -1) }}
        title="Downvote"
      >
        <svg width="11" height="11" viewBox="0 0 12 12" fill="currentColor">
          <path d="M6 11 L1 4 L5 4 L5 1 L7 1 L7 4 L11 4 Z" />
        </svg>
        <span>{downs}</span>
      </button>
    </div>
  )
}
